import * as React from 'react'
import { Hub } from '@aws-amplify/core'
import {
  AUTH_STATE_CHANGE_EVENT,
  AuthState,
  UI_AUTH_CHANNEL,
} from '@aws-amplify/ui-components'
import { doPostMessage, Messages } from '../utils/PostMessages'
import { Auth } from 'aws-amplify'
import Cookies from 'universal-cookie'
import { PersistentCookiesKeys } from '@app/enums/persistentCookiesKeys'
import LoginV1Service from '@app/services/ApplicationV1Bridge'
import { AppDispatch } from '@app/index'
import { setTrackSignIn } from '@app/store/actions/ApplicationConfigurationActions'

import { endpoints } from '@app/api/config'
import { apiAuthClient } from '@app/services/apiAuthClient'
import axios from 'axios'

const persistAuthExpiration = () => {
  const date = new Date()
  localStorage.setItem(
    'auth-expiration',
    String(date.setDate(date.getDate() + 1))
  )
}

export default class AuthService {
  static setCsrfCookie = async (token: string) => {
    await axios.post(
      endpoints.csrf,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    )
  }

  static setSessionCookie = async () => {
    await Auth.currentSession().then(async (session: any) => {
      const accessToken = session.getAccessToken()
      const jwt = accessToken.getJwtToken()
      // set now csrf cookie as well
      await LoginV1Service.setupSessionCookie(
        jwt,
        process.env.REACT_APP_V1_COOKIE_DOMAIN ?? ''
      )
      await AuthService.setCsrfCookie(jwt)
    })
  }

  static onLogin = async (keepMeLogged: boolean, dispatch?: AppDispatch) => {
    const urlPath: string = window.location.pathname
    await AuthService.setSessionCookie()
    // to be safe, every time an user does a login we delete the LB_imp cookie (SB-522)
    const cookies = new Cookies()
    cookies.remove(PersistentCookiesKeys.LbImp, {
      path: '/',
      domain: process.env.REACT_APP_V1_COOKIE_DOMAIN,
    })

    if (!keepMeLogged) {
      persistAuthExpiration()
    }
    if (urlPath.includes('/fbAppStore')) {
      doPostMessage(Messages.AppInvoked)
      doPostMessage(Messages.UserLogged)
    }
    Hub.dispatch(UI_AUTH_CHANNEL, {
      event: AUTH_STATE_CHANGE_EVENT,
      message: AuthState.SignedIn,
      data: null,
    })
    if (dispatch) {
      dispatch(setTrackSignIn(true))
    }
  }

  static onLoginAsync = async (
    keepMeLogged: boolean,
    dispatch?: AppDispatch
  ) => {
    return await AuthService.setSessionCookie().then(() => {
      if (!keepMeLogged) {
        persistAuthExpiration()
      }
      Hub.dispatch(UI_AUTH_CHANNEL, {
        event: AUTH_STATE_CHANGE_EVENT,
        message: AuthState.SignedIn,
        data: null,
      })
      if (dispatch) {
        dispatch(setTrackSignIn(true))
      }
    })
  }
}
